import React from "react";
import flogo from "../static/style/img/flogo.png";
import "../static/style/footer.css";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

export default () => {
  return (
    <div className="footer-container ">
      <div className="container">
        <div className={"footer-row row align-items-center"}>
          <div className={"col-md-12 text-center"}>
            <img className="logo" src={flogo} alt="Brang logo" />
          </div>
          <div
            className={"col-md-6 col-xs-12  nav-container-footer text-center"}
          >
            <Link className="nav-link" to="/contact">
              <FormattedMessage id="app.nav.contact" defaultMessage="YHTEYSTIEDOT" />
            </Link>
          </div>
          <div
            className={"col-md-6 col-xs-12  nav-container-footer text-center"}
          >
            <Link className="nav-link" to="/privacy-policy">
              <FormattedMessage
                id="app.nav.privacy_policy"
                defaultMessage="TIETOSUOJASELOSTE"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Footer.js